export enum LoopitProductType {
  ADD_DRIVE = 'Add Drive',
  LIABILITY_PROTECTION = 'Liability Protection',
  KM_BOOSTER_PLAN = 'KM Booster Plan',
}
